@use '../../styles/mixins' as *;

// Фасад на Mantine Accordion: слоты → легаси-BEM (см. CLASS_NAMES в Accordion.tsx):
// __item-wrap = item, __item = control (кнопка-строка), __item-inner = label,
// __item-icon = chevron, __panel/__content — панель/контент. Разделители-«линии» легаси
// (border-top у строки, inset 20px, скрытие на hover/opened/first) — на ::before/::after
// контрола: у Mantine строка-кнопка сама несёт горизонтальный паддинг.
.rf-accordion {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.rf-accordion__item-wrap {
    border-radius: 12px;
    border: 0;
    background: transparent;
    transition: background-color 0.2s ease-in-out;

    @include type-body-lg;
}

// Строка-заголовок (Mantine Control — <button>): геометрия легаси-.rf-accordion__item.
.rf-accordion__item {
    position: relative;
    width: 100%;
    padding: 0 20px;
    cursor: pointer;
    background: transparent;
    border-radius: 12px;

    // Mantine рисует hover-фон на самом контроле — легаси подсвечивал весь блок (см. ниже).
    &:hover {
        background: transparent;
    }

    &:focus-visible {
        @include a11y(8px);
    }

    // Верхний разделитель между элементами: inset по паддингу строки (паритет border-top
    // легаси-__item-inner). У первого элемента и у раскрытого — скрыт.
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 20px;
        right: 20px;
        border-top: 1px solid var(--neutral-20);
        transition: border-color 0.2s ease-in-out;
    }
}

.rf-accordion__item-wrap:first-child .rf-accordion__item::before,
.rf-accordion__item-wrap--opened .rf-accordion__item::before {
    border-color: transparent;
}

// Нижний разделитель последнего элемента (легаси border-bottom у __item-inner).
.rf-accordion__item-wrap:last-child .rf-accordion__item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    border-bottom: 1px solid var(--neutral-20);
    transition: border-color 0.2s ease-in-out;
}

// Текстовая часть строки (Mantine Label): вертикальный паддинг легаси-__item-inner.
.rf-accordion__item-inner {
    padding: 16px 0;
}

// Шеврон (Mantine Chevron — поворот на 180° при раскрытии даёт сам Mantine).
.rf-accordion__item-icon {
    color: var(--neutral-50);
    transition: 0.2s ease-in-out;
}

// hover-подсветка всего блока (только hoverable): фон + скрытие своего и следующего
// разделителя (паритет легаси-«танца границ»).
.rf-accordion__item-wrap--hoverable:not(.rf-accordion__item-wrap--disabled):hover {
    background-color: var(--neutral-05);
}

.rf-accordion__item-wrap--hoverable:hover .rf-accordion__item::before,
.rf-accordion__item-wrap--hoverable:hover + .rf-accordion__item-wrap .rf-accordion__item::before,
.rf-accordion__item-wrap--hoverable:last-child:hover .rf-accordion__item::after {
    border-color: transparent;
}

.rf-accordion__item-wrap--disabled {
    pointer-events: none;

    .rf-accordion__item-icon {
        color: var(--neutral-30);
    }
}

// Контент панели: паддинги и цвет легаси-__panel в раскрытом состоянии
// (высоту/анимацию даёт Mantine Collapse, свой Mantine-паддинг контента перекрываем).
.rf-accordion__content {
    padding: 16px 20px;
}

.rf-accordion__panel {
    color: var(--neutral-50);
}
